<template>
    <div class="background_white d_wrap_wordui">
        <div class="wrap_first_line_word d-flex flex-row align-items-center">
            <div class="d_word blue">{{word}}</div>
            <div class="d_pos">{{pos}}</div>
        </div>
        <div class="wrap_first_line_word d-flex flex-row align-items-center">
            <div class="d_ipa color_gray_text">{{ipa}}</div>
            <div class="d_pronunciation_uk color_us cursor_pointer" @click="playSound(pronounciationUK['mp3'])"
                 :title="pronounciationUK['pronunciation']" v-if="pronounciationUK">
                <i class="fas fa-volume-up margin-right-5 margin-left-5"></i>
                <span>uk</span></div>
            <div class="d_pronunciation_us margin-left-5 color_uk cursor_pointer"
                 @click="playSound(pronounciationUS['mp3'])" :title="pronounciationUS['pronunciation']" v-if="pronounciationUS">
                <i class="fas fa-volume-up margin-right-5 margin-left-5"></i>
                <span>us</span></div>
        </div>

        <div class="d_wrap_defines">
            <div class="d_wrap_define" v-for="define in defines" :key="define['define']">
                <div class="d_wrap_define">
                    <div class="d_define">
                    <span class="d_gramg_word color_gray_light_text">
                        {{define['gramg_word']}}
                    </span>
                        {{define['define']}}
                    </div>
                </div>
                <div class="d_wrap_examples">

                    <div v-for="sentenceExample in define['example']" class="d_sentence_example" :key="sentenceExample">
                        {{sentenceExample}}
                    </div>

                </div>
            </div>
        </div>

        <div class="d_wrap_box d_wrap_idioms" v-if="idioms && idioms.length > 0">
            <div class="d_heading_title color_yellow">Idioms</div>
            <div class="d_wrap_idiom" v-for="idiom in idioms" :key="idiom['word']">
                <div class="d_idiom_phrase">{{idiom['word']}}</div>
                <div class="d_idiom_define">{{idiom['define']}}
                </div>
                <div class="d_wrap_idiom_examples">
                    <div class="d_idiom_example" v-for="idiomExample in idiom['examples']" :key="idiomExample">
                        {{idiomExample}}
                    </div>
                </div>
            </div>
        </div>

        <div class="d_wrap_box d_wrap_phrasals" v-if="phrasals && phrasals.length > 0">
            <div class="d_heading_title color_yellow">Phrasal Verbs</div>
            <div class=" d-flex flex-wrap">
                <div class="d_word_pharasals color_word_other" v-for="phrasal in phrasals" :key="phrasal">{{phrasal}}
                </div>
            </div>
        </div>
        <div class="d_wrap_box d_wrap_synonyms" v-if="synonyms && synonyms.length > 0">

            <div class="d_heading_title color_yellow">Synonyms</div>
            <div class="d_wrap_synonym d-flex flex-wrap">
                <div class="d_word_synonym color_word_other" v-for="synonym in synonyms" :key="synonym">
                    {{synonym}}
                </div>
            </div>
        </div>

    </div>

</template>

<script>

    export default {
        name: 'WordUI',
        components: {},
        props: {
            wordResponseApi: null
        },
        data: function () {
            return {
                word: null,
                pos: null,
                ipa: null,
                pronounciationUS: null,
                pronounciationUK: null,
                defines: null,
                idioms: null,
                phrasals: null,
                synonyms: null
            }
        },
        async mounted() {
            // console.info('wordResponseApi', this.wordResponseApi)
            // this.word = this.wordResponseApi.word
            let {word, pos, ipa, pronounciationUS, pronounciationUK, defines, idioms, phrasals, synonyms} = this.transformResponseToData(this.wordResponseApi)
            this.word = word
            this.pos = pos
            this.ipa = ipa
            this.pronounciationUS = pronounciationUS
            this.pronounciationUK = pronounciationUK
            this.defines = defines
            this.idioms = idioms
            this.phrasals = phrasals
            this.synonyms = synonyms
            // console.log(word)
        },
        methods: {
            transformResponseToData(wordResponseApi) {
                let word = wordResponseApi['word']
                let pos = wordResponseApi['pos']
                // let prons =
                let pronounciationUS = null
                let pronounciationUK = null
                let ipa = null
                for (let pron of wordResponseApi['prons']) {
                    let urlMp3 = pron['mp3']
                    let pronounciation = {}
                    pronounciation['mp3'] = pron['mp3']
                    pronounciation['pronunciation'] = pron['pronunciation']

                    if (urlMp3.includes('uk_pron') && pronounciationUK == null) {
                        ipa = pronounciation['pronunciation']
                        pronounciationUK = pronounciation
                    } else if (urlMp3.includes('us_pron') && pronounciationUS == null) {
                        pronounciationUS = pronounciation
                    }
                }

                let defines = wordResponseApi['defines']
                let idioms = wordResponseApi['idioms']
                let phrasals = wordResponseApi['phrasals']
                let synonyms = wordResponseApi['synonyms']
                return {word, pos, ipa, pronounciationUS, pronounciationUK, defines, idioms, phrasals, synonyms}
            },
            playSound(sound) {
                if (sound) {
                    let audio = new Audio(sound)
                    audio.play()
                }
            }

        }
    }
</script>

<style>

</style>
